import { ComponentProps } from 'react';
import { px } from '../../utils/styles/px';
import { Flex } from '../layout/Flex';
import { DESKTOP_MENU_WIDTH } from './DashboardLayout';
import { CONTENT_WIDTH } from './constants';

interface DashboardPageProps extends ComponentProps<typeof Flex> {
    centered?: boolean;
}

export const DashboardPage = (props: DashboardPageProps) => {
    const { centered = true, children, ...other } = props;

    return (
        <Flex width="100%" minHeight="100%" pr={{ lg: centered ? px(DESKTOP_MENU_WIDTH) : 0 }}>
            <Flex
                as="main"
                width="100%"
                minHeight="100%"
                mx={centered ? 'auto' : undefined}
                py={{ sm: 2 }}
                px={{ sm: 2, md: 4 }}
                maxWidth={{ sm: CONTENT_WIDTH }}
                {...other}
            >
                {children}
            </Flex>
        </Flex>
    );
};
